import { useEffect, useMemo, useRef } from 'react';
import gsap from 'gsap';
import { useDetailViewContext } from '../context/DetailViewContext';
import FocusPoints from '../data/FocusPoints';

/**
 * Creates a timeline that only animates when the section is active
 * @param sectionID
 * @param pauseOnFocusPoint
 */
export default function useDetailSectionAnimation(sectionID: string, pauseOnFocusPoint?: FocusPoints, resetAnimation?: () => void): gsap.core.Timeline
{
  const { activeDetailID, detailViewVisible, activeFocusID } = useDetailViewContext();
  const isVisible = useRef(false);

  const animation = useMemo(() =>
  {
    const timeline = gsap.timeline();
    timeline.pause();
    timeline.uuid = Math.random();
    return timeline;
  }, []);

  useEffect(() =>
  {
    const isCorrectDetailVisible = detailViewVisible && activeDetailID === sectionID;

    if (activeFocusID === pauseOnFocusPoint || !isCorrectDetailVisible) {
      console.log(sectionID, 'pause');
    }
    else {
      // need to start from the beginning only if visibility changed
      if (isVisible.current) {
        animation.play();
      }
      else {
        if (resetAnimation)
          resetAnimation();

        animation.play(0);
      }
    }

    isVisible.current = isCorrectDetailVisible;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [animation, activeDetailID, sectionID, detailViewVisible, activeFocusID, pauseOnFocusPoint]);

  return animation;
}